module.exports = __webpack_public_path__ + "img/5709495.jpg";